module.exports = __webpack_public_path__ + "img/2.d50d7d8c.png";